import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHeader";
import { COMPANY, PAGE_HEROES } from "../data/site";

export default function Contact() {
  const hero = PAGE_HEROES.contact;
  return (
    <div data-testid="contact-page" className="bg-[#f7f4ec]">
      <PageHero image={hero.image} title={hero.title} subtitle={hero.subtitle} testId="contact-hero" />

      <section className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7 space-y-10">
            <div data-testid="contact-phone-block">
              <p className="overline text-[#b8895a]">Phone</p>
              <a
                href={COMPANY.phoneHref}
                className="font-serif text-5xl md:text-6xl text-[#13263c] mt-3 block hover:text-[#b8895a] transition-colors leading-none"
                data-testid="contact-phone"
              >
                {COMPANY.phone}
              </a>
            </div>
            <div data-testid="contact-email-block">
              <p className="overline text-[#b8895a]">Email</p>
              <a
                href={COMPANY.emailHref}
                className="font-serif text-3xl md:text-5xl text-[#13263c] mt-3 block hover:text-[#b8895a] transition-colors break-all leading-tight"
                data-testid="contact-email"
              >
                {COMPANY.email}
              </a>
            </div>
            <div data-testid="contact-location-block">
              <p className="overline text-[#b8895a]">Location</p>
              <p className="font-serif text-3xl md:text-4xl text-[#13263c] mt-3">
                {COMPANY.location}
              </p>
              <p className="mt-2 text-[#737373] text-sm max-w-md">
                Home base address shared after booking confirmation.
              </p>
            </div>
          </div>

          <aside className="md:col-span-5">
            <div className="surface-card rounded-md p-10">
              <p className="overline">Ready to book?</p>
              <h2 className="font-serif text-3xl md:text-4xl text-[#13263c] mt-3 leading-tight">
                Let's get you on the water.
              </h2>
              <hr className="accent-rule mt-3" />
              <p className="mt-5 text-[#4a4a4a] leading-relaxed">
                Online reservations open soon. Until then, a quick call or email is the fastest way to hold a date.
              </p>
              <Link
                to="/book"
                data-testid="contact-book-cta"
                className="btn-primary mt-8"
              >
                Book Now
              </Link>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
